"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchResultItemContent = void 0;
exports.SearchResultItemContent = {
  en: {
    addToCart: "Add to Cart",
    moreProducts: "More products",
    otherProducts: "Other Products",
    matchingProducts: "Matching Products",
    productCategories: "Product Categories",
    articlesResources: "Articles & Resources",
    recentlyPurchasedProducts: "Recently Purchased Products",
    tbd: "TBD",
    noResults: "No results found"
  },
  fr: {
    addToCart: "Ajouter chariot",
    moreProducts: "Plus de produits",
    otherProducts: "Autres produits",
    matchingProducts: "Produits assortis",
    productCategories: "Catégories de Produits",
    articlesResources: "Articles et ressources",
    recentlyPurchasedProducts: "Produits récemment achetés",
    tbd: "à déterminer",
    noResults: "Aucun résultat trouvé"
  },
  es: {
    addToCart: "Añadir al carrito",
    moreProducts: "Más productos",
    otherProducts: "Otros productos",
    matchingProducts: "Productos a juego",
    productCategories: "Categorías de Producto",
    articlesResources: "Artículos y recursos",
    recentlyPurchasedProducts: "Productos comprados recientemente",
    tbd: "por determinar",
    noResults: "No se encontraron resultados"
  }
};